import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { FilterInput } from '../../../../common/filterInput'
import LineinputV2 from '../../../../common/lineinputV2'
import { focusElemnt, getFloat } from '../../../../common/helper'
import TablePaginationCustom from '../../../../common/TablePagination'

const CityPairTable = (props) => {
    const {tableData, setTableData, filters, setFilters, editData, setEditData, reportData, handleSearch, totalNoOfRows} = props
    // const [rowsPerPage, setRowsPerPage] = useState(10)
    // const [page, setPage] = useState(0)
    const {rowsPerPage, setRowsPerPage,page, setPage} = props
    const [searchData, setSearchData] = useState({
        ServiceTypeID: "",
        ServiceType: "",
        ConsignmentSubTypeID: "",
        SubType: "",
        FromCityName: "",
        ToCityName: "",
        Rate: "",
        LocalRate:'',
        ETADays:''
      })
    const columnTable = [
        { headerName: 'Service Type ID', field: 'ServiceTypeID', headerSx: { width: "120px" }, inputField: false },
        { headerName: 'Service Type', field: 'ServiceType', headerSx: { width: "120px" }, inputField: false },
        { headerName: 'Consignment ID Type', field: 'ConsignmentSubTypeID', headerSx: { width: "140px" }, inputField: false },
        { headerName: 'Consignment Type', field: 'SubType', headerSx: { width: "140px" }, inputField: false },
        { headerName: 'Source City Name', field: 'FromCityName', headerSx: { width: "140px" }, inputField: false },
        { headerName: 'Destination City Name', field: 'ToCityName', headerSx: { width: "140px" }, inputField: false },
        { headerName: 'Min Freight', field: 'MinFreight', headerSx: { width: "140px" }, inputField: true },
        { headerName: 'Freight Rate', field: 'Rate', headerSx: { width: "140px" }, inputField: true },
        { headerName: 'Local Freight Rate', field: 'LocalRate', headerSx: { width: "140px" }, inputField: true },
        { headerName: 'ETA Days', field: 'ETADays', headerSx: { width: "140px" }, inputField: true },
    ]
    const handleChangeContain = (event, field) => {

    }
    // const handleChange = (e, key, index, row) => {
    //     let newRow = {...row}
    //     newRow[key] = e.target.value
    //     console.log('Hi')
    //     console.log(e, key, index)
    //     let newData = [...tableData]
    //     newData[index][key] = e.target.value
    //     setTableData(newData)
    // }
    const handleChange = (e, key, index, row) => {
        // Update the main tableData
        const updatedRow = { ...row, [key]: e.target.value }
        const newData = [...tableData]
        newData[index] = updatedRow
        setTableData(newData)

        // Update the modifiedRows state
        setEditData(prevModifiedRows => {
            const existingIndex = prevModifiedRows.findIndex(modifiedRow => modifiedRow.ConsignmentSubTypeID === updatedRow.ConsignmentSubTypeID && modifiedRow.FromCityID === updatedRow.FromCityID && modifiedRow.ToCityID === updatedRow.ToCityID)
            if (existingIndex !== -1) {
                // Update existing row in modifiedRows
                const updatedModifiedRows = [...prevModifiedRows]
                updatedModifiedRows[existingIndex] = updatedRow
                return updatedModifiedRows
            } else {
                // Add new modified row to modifiedRows
                return [...prevModifiedRows, updatedRow]
            }
        })
    }
    useEffect(() => {
        let fiterData = reportData?.filter((val) =>
            (searchData?.ServiceTypeID === "" || (val?.ServiceTypeID && val?.ServiceTypeID?.toString().toLocaleLowerCase().includes(searchData?.ServiceTypeID))) &&
            (searchData?.ServiceType === "" || (val?.ServiceType && val?.ServiceType?.toLocaleLowerCase().includes(searchData?.ServiceType?.toLocaleLowerCase()))) &&
            (searchData?.ConsignmentSubTypeID === "" || (val?.ConsignmentSubTypeID && val?.ConsignmentSubTypeID?.toString().toLocaleLowerCase().includes(searchData?.ConsignmentSubTypeID))) &&
            (searchData?.SubType === "" || (val?.SubType && val?.SubType?.toLocaleLowerCase().includes(searchData?.SubType?.toLocaleLowerCase()))) &&
            (searchData?.FromCityName === "" || (val?.FromCityName && val?.FromCityName?.toLocaleLowerCase().includes(searchData?.FromCityName?.toLocaleLowerCase()))) &&
            (searchData?.ToCityName === "" || (val?.ToCityName && val?.ToCityName?.toLocaleLowerCase().includes(searchData?.ToCityName?.toLocaleLowerCase()))) &&
            (searchData?.MinFreight === "" || (val?.MinFreight && val?.MinFreight.toString().includes(searchData?.MinFreight))) &&
            (searchData?.Rate === "" || (val?.Rate && val?.Rate.toString().includes(searchData?.Rate))) &&
            (searchData?.LocalRate === "" || (val?.LocalRate && val?.LocalRate.toString().includes(searchData?.LocalRate))) &&
            (searchData?.ETADays === "" || (val?.ETADays && val?.ETADays.toString().includes(searchData?.ETADays)))
        );
        setTableData(fiterData);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchData]);
      const handleSearchData = (event, field) => {
        let value = event.target.value.toString(); // Convert value to string
        setSearchData({ ...searchData, [field]: value });
      }
    return (
        <Box style={{paddingTop:'10px'}}>
            <TableContainer className='scrollBlue' component={Paper} style={{ marginBottom: '5px', maxHeight:'54vh' }}>
                <Table
                    stickyHeader
                    size="small"
                    aria-label="a dense table"
                    sx={{
                        '&.MuiTableCell-root': {
                            padding: '6px 8px!important',
                        },
                    }}
                >
                    <TableHead style={{ position: `sticky`, top: `0`, zIndex: 2 }}>
                        <TableRow>
                            <TableCell colSpan={columnTable?.length} sx={{
                                backgroundColor: '#BFE1FF',
                                fontSize: '12px',
                                fontWeight: '600',
                                color: '#444',
                                height: '40px'
                            }}>
                                Consignment Type: {filters?.consignmentType?.name}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            {columnTable?.map((col, index) => (
                                <TableCell key={`CityHeader-${index}`} sx={{
                                    ...col.headerSx,
                                    backgroundColor: '#DAEDFE',
                                    fontSize: '12px',
                                    fontWeight: '600',
                                    color: '#444',
                                    height: '40px'
                                }}>
                                    {col.headerName}
                                </TableCell>
                            ))}

                        </TableRow>
                        <TableRow>
                            {columnTable?.map((col, index) => (
                                <TableCell
                                    key={`TH-${index}`}
                                    sx={{
                                        ...col.headerSx,
                                        height: '40px',
                                        fontSize: '12px',
                                        fontWeight: '600',
                                        color: '#444',
                                    }}
                                >
                                    <FilterInput label="Contains" onChange={(e) => handleSearchData(e, col.field)} />
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    {tableData?.length > 0 ? <TableBody>
                        { tableData?.map((val, index) => (
                            <TableRow key={`CityPairDataCol-${index}`}>
                                {columnTable.map((col, index1) => (
                                    <>
                                        {!(col?.inputField) ?
                                            <TableCell
                                                key={`CityPairDataCol-${index}-${index1}`}
                                                sx={{
                                                    ...col.headerSx,
                                                    height: '40px',
                                                    fontSize: '12px',
                                                    fontWeight: '500',
                                                    color: '#444',
                                                }}
                                            >
                                                {val?.[col.field]}
                                            </TableCell>
                                            :
                                            <TableCell>
                                                <div className='CityPairRateMatrix'>
                                                    <div className="input--wrapper">
                                                        <LineinputV2
                                                            id={`input-${index}-${index1}`}
                                                            value={val?.[col.field]}
                                                            name="value"
                                                            type="text"
                                                            filter={getFloat}
                                                            onBlur={(e)=>{
                                                                handleChange(e,col.field, index , val)}}
                                                            // onBlur={(event) => {
                                                            //     if (event.key === 'Enter') {
                                                            //         setTimeout(() => {
                                                            //         }, 0)
                                                            //     } else if (event.key === 'Escape') {
                                                            //         setTimeout(() => {
                                                            //         }, 0)
                                                            //     }
                                                            // }}
                                                        />
                                                    </div>
                                                </div>
                                            </TableCell>}
                                    </>
                                ))}
                            </TableRow>
                        ))}
                    </TableBody>:
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={columnTable?.length}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          marginTop: '20px',
                          marginBottom: '20px',
                          color: 'red',
                          fontSize: '14px',
                        }}
                      >
                        <span>No Results Found For The Selected Filters.</span>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableBody>}
                </Table>
            </TableContainer>
            <TablePaginationCustom totRowCount={totalNoOfRows} rowsPerPageOptions={[10, 20, 50, 100, 200, 500]} rowsPerPage={rowsPerPage} page={page} handleChangePage={(event, newPage) => {
                setPage(newPage);handleSearch(newPage,rowsPerPage)
            }} handleChangeRowsPerPage={(event) => {
                setRowsPerPage(parseInt(event.target.value, 10));
                setPage(0);
                handleSearch(0,parseInt(event.target.value, 10))
            }} />
        </Box>
    )
}

export default CityPairTable